import { useStreamUserDefinedRange } from '../../stores/stream-screen.store';

/**
 * Returns whether the current user-defined stream range is entirely in the future.
 * Used to skip segment fetches and show a dedicated message when the user selects a future date.
 */
export function useIsStreamRangeInFuture(): boolean {
  const { from, isLoading } = useStreamUserDefinedRange();

  return !isLoading && from >= Date.now();
}
